import React from 'react'
import { List, ListItem, ListItemButton, ListItemIcon, ListItemText, Paper, Typography } from '@mui/material'
import CookieIcon from '@mui/icons-material/Cookie'
import CopyrightIcon from '@mui/icons-material/Copyright'
import GavelIcon from '@mui/icons-material/Gavel'
import PolicyIcon from '@mui/icons-material/Policy'

const FooterCol1 = (props) => {
  return (
    <Paper sx={{m: 1, p: 1,}}>
      <Typography component="h3" fontWeight={600} variant="h6">Legal</Typography>
      <List>
        {/* Cookie Policy */}
        <ListItem disablePadding>
          <ListItemButton href="/privacy/#cookies">
            <ListItemIcon>
              <CookieIcon />
            </ListItemIcon>
            <ListItemText primary="Cookie Policy" />
          </ListItemButton>
        </ListItem>
        {/* Legal Notice */}
        <ListItem disablePadding>
          <ListItemButton href="/privacy/#legal-notice">
            <ListItemIcon>
              <CopyrightIcon />
            </ListItemIcon>
            <ListItemText primary="Legal Notice" />
          </ListItemButton>
        </ListItem>
        {/* Privacy Policy */}
        <ListItem disablePadding>
          <ListItemButton href="/privacy/">
            <ListItemIcon>
              <PolicyIcon />
            </ListItemIcon>
            <ListItemText primary="Privacy Policy" />
          </ListItemButton>
        </ListItem>
        {/* Terms of Use */}
        <ListItem disablePadding>
          <ListItemButton href="/privacy/#terms-of-use">
            <ListItemIcon>
              <GavelIcon />
            </ListItemIcon>
            <ListItemText primary="Terms of Use" />
          </ListItemButton>
        </ListItem>
      </List>
    </Paper>
  )
}

export default FooterCol1